module.exports = __webpack_public_path__ + "static/media/CM-marca_preferencial-positiva-RGB.14dfdc09.png";